import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=13dc21d5&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=ts&"
export * from "./FileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=13dc21d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc21d5",
  null
  
)

/* custom blocks */
import block0 from "./FileUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports